import { ReactNode } from 'react'
import styled, { css } from 'styled-components'

interface HeadingTitleProps {
  children: ReactNode
}

const HeadingTitle = ({ children }: HeadingTitleProps) => {
  return <StyledWrapper>{children}</StyledWrapper>
}

export default HeadingTitle

const StyledWrapper = styled.h1`
  ${({ theme }) => css`
    font-size: 32px;
    font-weight: bold;
    letter-spacing: -1.28px;
    color: ${theme.color.text_1};
    font-family: 'GmarketSansMedium';
    white-space: pre;
    text-align: center;
    & > strong {
      color: ${theme.color.primary_2};
    }
  `}
`
